export function ImageLinks() {
    const widgetName = '.widget-image-links';

    const setComponent = () => {
        const $goButton = $(`${widgetName} .go`);
        const $imageLinks = $(`${widgetName} .image-link`);

        $('html').on('click', function () {
            hideLinks(false);
        });

        $goButton.on('click', function (e) {
            if ($(this).parents('div').hasClass('link-left')) {
                hideLinks(true);
                $(this).parents('.link-left').addClass('show');
            } else if ($(this).parents('div').hasClass('link-right')) {
                hideLinks(true);
                $(this).parents('.link-right').addClass('show');
            } else {
                hideLinks(false);
            }
            e.stopPropagation();
        });

        function hideLinks(shownOnly) {
            if ($imageLinks.length) {
                $imageLinks.each(function () {
                    if (!shownOnly || (shownOnly && $(this).hasClass('show'))) {
                        $(this).removeClass('show');
                    }
                })
            }
        }
    }

    const init = () => {
        if ($(widgetName).length) {
            setComponent();
        }
    }

    init();
}